import React from 'react';
import {useDropzone} from 'react-dropzone';
import "./FileDropzone.css";

function DropZone(props) {
  const {getRootProps, getInputProps} = useDropzone({
    accept: props.accept,
    onDrop: acceptedFiles => {
      props.handleSelection(acceptedFiles);
    }
  });

  return (
    <section className="container">
        <div id="dropzone" {...getRootProps({className: 'dropzone'})} className="dropzone" >
            <input id="dropzoneInput" {...getInputProps()} />
            <p>Drag and drop into this box, or click to select file</p>
        </div>
    </section>
  );
}

export default DropZone;